import { useEffect, useMemo } from 'react';
import { onPageChange, TrackingConfigProvider } from '@givelify/utils';
import { useSelector } from 'react-redux';
import { Outlet, useLocation, useSearchParams } from 'react-router-dom';
import { AppState } from 'store';
import { ThemeWrapper } from 'ThemeWrapper';
import {
    getGoogleTagManagerTag,
    GTM_TAG_VALUE,
} from 'utils/getGoogleTagManagerTag';
import { getEventTrackingData } from 'utils/tracking';
import { GasRouterProvider } from './GasRouterProvider';
import '../i18n';

export const RoutesWrapper = () => {
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        onPageChange();
    }, [location.pathname]);

    const { doneeId, user, donee } = useSelector((state: AppState) => ({
        doneeId: state.Donee.donee?.id,
        user: state.User.user,
        donee: state.Donee.donee,
        mainDoneeId: state.Donee.campuses ? state.Donee.campuses[0].id : null,
    }));

    const tag = useMemo(
        () =>
            donee
                ? getGoogleTagManagerTag(
                      donee.onboarding?.hasMid,
                      donee.lastDonationDate,
                  )
                : null,
        [donee],
    );

    useEffect(() => {
        // when doneeId is missing it means donee data is not loaded yet
        if (!doneeId) return;

        const targetParams = new URLSearchParams(searchParams);

        targetParams.delete('Onboarding');
        targetParams.delete('MIDApproved');

        if (tag) {
            targetParams.set(tag, GTM_TAG_VALUE);
        }

        if (targetParams.toString() !== searchParams.toString()) {
            setSearchParams(targetParams, { replace: true });
        }
        // listen only to tag and doneeId change
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tag, doneeId]);

    return (
        <GasRouterProvider>
            <TrackingConfigProvider
                getPayload={() => getEventTrackingData(user, donee)}
            >
                <ThemeWrapper>
                    <Outlet />
                </ThemeWrapper>
            </TrackingConfigProvider>
        </GasRouterProvider>
    );
};
